export const MENU_ROLE_ACTION = "MENU_ROLE_ACTION";
export const MENU_ROLE_PARTNER_ACTION = "MENU_ROLE_PARTNER_ACTION";
export const MENU_ROLE_SUPER_ACTION = "MENU_ROLE_SUPER_ACTION";
